import { FormulaireContactB2C } from '@components/formulaire-contact-b2c/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const formulaireContactB2cMock: Block<FormulaireContactB2C> = {
  type: 'formulaire-contact-b2c',
  data: {
    phoneSection: {
      title: {
        text: 'Une question ? \\\\[[Appelez-nous !]]',
        as: 'h2',
      },
      text: `<p>Vous avez une question sur nos produits, nos services ou notre réseau de magasins, nos conseillers sont à votre écoute.</p>`,
      phonePreamble: `Service client SoCoo'c :`,
      phoneNumber: '0450660606',
      cta: {
        label: `Solution sourds et malentendants`,
        url: 'https://socooc.elioz.fr/3.0/?hash=7c19b1d3ce604622f6f03787f993043b',
      },
    },
    formSection: {
      title: {
        text: `Un petit message et on s'occupe [[du reste]]`,
        as: 'h2',
      },
      requestTypes: [
        {
          label: 'Un renseignement',
          key: '/contact_types/un_renseignement',
        },
        {
          label: 'Une commande en cours',
          key: '/contact_types/commande_en_cours',
        },
        {
          label: 'Le SAV',
          key: '38671',
        },
        {
          label: 'Les électros',
          key: '39379',
        },
      ],
      requestTypesInformations: [
        {
          label: 'Suivi de la commande',
          key: '00001',
        },
        {
          label: 'Information magasin',
          key: '00002',
        },
      ],
      legalNoticeHtml: `<p>Pour connaître l’utilisation que nous faisons des données collectées par ce formulaire et exercer vos droits sur vos données personnelles, notamment en matière d’accès et de suppression, veuillez consulter notre <a href="/charte" />notre charte de confidentialité</a>.</p>`,
    },
    clientSection: {
      title: {
        text: 'Déjà client ?',
        as: 'h2',
      },
      text: `<p>Prenez contact directement avec votre magasin !</p>`,
      cta: {
        label: 'Trouver mon magasin',
        url: '/magasins',
      },
    },
    image: imageMock,
    gtmConfigSubmit: {
      event: 'submit_cta_contact',
      group: 'contact',
      description: 'page contact client',
      context: 'clic bouton validation formulaire',
    },
  },
};
